module.exports = __webpack_public_path__ + "static/media/036.c24b036e.jpg";